// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.stand-by-event__fields-wrapper[data-v-133fb1b0] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: calc(100% + 15px);\n  margin: 15px -7.5px 0;\n}\n.stand-by-event__field[data-v-133fb1b0] {\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n  -ms-flex-preferred-size: 50%;\n      flex-basis: 50%;\n  margin: 0 7.5px;\n}\n", ""]);
// Exports
module.exports = exports;
